var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareddocumenticons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3105_7612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 9.52661C13.2815 9.52678 14.3197 10.5657 14.3197 11.8469C14.3195 13.128 13.2814 14.1661 12.0004 14.1663C10.7192 14.1663 9.68022 13.1281 9.68005 11.8469C9.68005 10.5656 10.7191 9.52661 12.0004 9.52661Z",
    stroke: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.333 1.43286H12.667C12.994 1.43295 13.3078 1.56297 13.5391 1.79419C13.7703 2.02541 13.9003 2.33928 13.9004 2.66626V6.56665H10.0996V2.66626C10.0997 2.33928 10.2297 2.02541 10.4609 1.79419C10.6922 1.56297 11.006 1.43295 11.333 1.43286Z",
    fill: "#0A0A0A",
    stroke: "#D9D9D9",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16663 18.4829C7.16617 18.4249 7.18529 18.3681 7.22131 18.3228C7.81605 17.6576 8.55026 17.1316 9.37073 16.7808C10.1948 16.4284 11.0863 16.2612 11.9821 16.2925L12.0006 16.2935L12.0192 16.2925C12.9136 16.2588 13.8045 16.4227 14.6285 16.772C15.4489 17.1196 16.1825 17.6434 16.7789 18.3052C16.8143 18.3495 16.8342 18.4046 16.8336 18.4614V19.4995H7.16663V18.4829Z",
    stroke: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7666 3.90039V5.43359H5.43359V21.2334H18.5664V5.43359H15.2334V3.90039H18.667C19.047 3.90048 19.4119 4.05061 19.6807 4.31934C19.9494 4.58806 20.0995 4.95298 20.0996 5.33301V21.333C20.0996 21.713 19.9493 22.0779 19.6807 22.3467C19.4119 22.6154 19.047 22.7665 18.667 22.7666H5.33301C4.95298 22.7665 4.58806 22.6154 4.31934 22.3467C4.05074 22.0779 3.90039 21.713 3.90039 21.333V5.33301C3.90048 4.95298 4.05061 4.58806 4.31934 4.31934C4.58806 4.05061 4.95298 3.90048 5.33301 3.90039H8.7666Z",
    fill: "#0A0A0A",
    stroke: "#D9D9D9",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3105_7612"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareddocumenticons);
export default __webpack_public_path__ + "static/media/Shared document icons.09212d559a9f71f48f40ff4b36afaba1.svg";
export { ForwardRef as ReactComponent };